import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { getFunnelExtra } from "../funnel";
import report from "../utils/report";
var Log = {
  reportor: null,
  /**
   * info日志
   * @param content 如果是对象{ title: string; msg?: string | Array<string> }，则需要上报到basemnt
   * @param infos 其他日志
   */
  logInfo: function logInfo(_ref, extra) {
    var title = _ref.title,
      _ref$msg = _ref.msg,
      msg = _ref$msg === void 0 ? '' : _ref$msg;
    try {
      var _Log$reportor;
      (_Log$reportor = Log.reportor) === null || _Log$reportor === void 0 ? void 0 : _Log$reportor.reportLog('info', "".concat(title, "-info"), msg, extra);
    } catch (error) {
      report({
        logType: 'error',
        title: 'tracker-error',
        msg: error
      });
    }
  },
  /**
   * 上报业务错误
   * @param title  错误title，监控项msg
   * @param msg 详细信息，监控项自定义字段
   */
  logError: function logError(_ref2, extra) {
    var title = _ref2.title,
      _ref2$msg = _ref2.msg,
      msg = _ref2$msg === void 0 ? '' : _ref2$msg;
    try {
      var _Log$reportor2;
      (_Log$reportor2 = Log.reportor) === null || _Log$reportor2 === void 0 ? void 0 : _Log$reportor2.reportLog('error', "".concat(title, "-error"), msg, extra);
    } catch (error) {
      report({
        logType: 'error',
        title: 'tracker-error',
        msg: error
      });
    }
  },
  /**
   * 上报jsbridge类型错误
   * @param param0
   * @param extra
   */
  logJSBridgeError: function logJSBridgeError(_ref3, extra) {
    var title = _ref3.title,
      _ref3$msg = _ref3.msg,
      msg = _ref3$msg === void 0 ? '' : _ref3$msg;
    try {
      Log.logError({
        title: title,
        msg: msg
      }, _objectSpread(_objectSpread({}, extra), {}, {
        _type: 'jsbridge'
      }));
    } catch (error) {
      report({
        logType: 'error',
        title: 'tracker-error',
        msg: error
      });
    }
  },
  /**
   * 上报请求信息
   * @param rpcInfo
   */
  reportRPC: function reportRPC(rpcInfo) {
    var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    try {
      var _Log$reportor3;
      (_Log$reportor3 = Log.reportor) === null || _Log$reportor3 === void 0 ? void 0 : _Log$reportor3.reportRPC(rpcInfo, extra);
    } catch (error) {
      report({
        logType: 'error',
        title: 'tracker-error',
        msg: error
      });
    }
  },
  /**
   * 上报漏斗模型
   * @param config 漏斗配置
   */
  reportFunnel: function reportFunnel(title, config) {
    try {
      var _Log$reportor4;
      (_Log$reportor4 = Log.reportor) === null || _Log$reportor4 === void 0 ? void 0 : _Log$reportor4.reportFunnel(title, getFunnelExtra(config));
    } catch (error) {
      report({
        logType: 'error',
        title: 'tracker-error',
        msg: error
      });
    }
  },
  set: function set() {
    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    try {
      Object.assign(Log, opt);
    } catch (error) {
      report({
        logType: 'error',
        title: 'tracker-error',
        msg: error
      });
    }
  }
};
export default Log;